import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{sq-walkthrough-popover class=this.popoverClasses step=this.step next=this.next close=(action \"close\") isActive=this.isActive}}", {
  moduleName: "@dashboard/shared-ui/components/setup-guide/action-item-complete-popover.hbs"
});